import styled from 'styled-components';

export const Container = styled.div``;

export const ContainerSupplier = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const SupplierName = styled.h4``;

export const ContainerProcurement = styled.div`
  background-color: ${({ theme }) => theme.grayLight};
  margin-bottom: 1rem;
  padding: 0.5rem;
`;

export const ContainerPart = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Column = styled.div<{ customWidth: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & > *:nth-child(1) {
    width: 23%;
  }

  & > *:nth-child(2) {
    margin-top: 15px;
    width: 50%;
  }

  & > *:nth-child(3) {
    width: 10%;
  }

  & > *:nth-child(5) {
    width: ${props => props.customWidth};
  }
`;
export const BoxImagePart = styled.div`
  img {
    width: 100%;
    max-width: 75px;
    max-height: 75px;
    min-width: 75px;
    min-height: 75px;
    object-fit: contain;
  }
`;

export const Quantity = styled.div`
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20%;
  margin: 0 auto;
`;

export const AreaReasonSupplier = styled.div``;

export const AreaCheckboxPart = styled.div`
  width: 16.8%;
  display: flex;
  justify-content: flex-end;
`;

